import styled from '@emotion/styled';

export const SelectWrapper = styled('div', { label: 'SelectWrapper' })`
    margin-top: -6px;
`;
